<script setup lang="ts">
import { ref } from 'vue';

import { useBreakpoints } from '@shop/composables/useBreakpoints';

import type { ContentItemLayoutProps } from './ContentItemLayout.types';

const props = withDefaults(defineProps<ContentItemLayoutProps>(), {
  initialShow: false,
  menuButtonLabel: '',
});

const { isMobile } = useBreakpoints();
const showMenu = ref(props.initialShow);

function toggleMenu(): void {
  showMenu.value = !showMenu.value;
}
</script>

<template>
  <div class="sidebarmenu">
    <Transition name="slide">
      <div v-if="!isMobile || showMenu" class="sidebarmenu__container">
        <slot name="sidebar" />
      </div>
    </Transition>

    <a
      v-if="isMobile && !showMenu"
      class="sidebarmenu__menu-button heading-h3"
      href="#"
      @click.prevent="toggleMenu"
    >
      <span class="icon icon--chevron_left icon--showleft">{{ menuButtonLabel }}</span>
    </a>

    <div v-if="!isMobile || !showMenu" class="sidebarmenu__content">
      <slot />
    </div>
  </div>
</template>
